import { useGetIcdCodes } from './useGetIcdCodes';
import { useGetReferralFieldSettings } from './useGetReferralFieldSettings';
import { useGetReferringProviders } from './useGetReferringProviders';

export const useReferralService = () => {
    const getIcdCodes = useGetIcdCodes();
    const getReferralFieldSettings = useGetReferralFieldSettings();
    const getReferringProviders = useGetReferringProviders();

    return {
        getIcdCodes,
        getReferralFieldSettings,
        getReferringProviders,
    };
};
